(function () {
    'use strict';

    angular
        .module('rms.common')
        .filter('filterBarAppliedFilter', filterBarAppliedFilter);

    function filterBarAppliedFilter(lodash, $filter, FILTER_OPERATOR_CONSTANT) {
        return function(filter, labels) {
            if (!lodash.has(filter, 'displayTemplate')) {
                filter.displayTemplate = '{0} {1} {2}';
            }

            let displayValue = filter.option_value || lodash.get(labels, 'value_empty', '<  >');
            if (lodash.has(filter, 'option_value')) {
                if ([FILTER_OPERATOR_CONSTANT.IN, FILTER_OPERATOR_CONSTANT.NOT_IN].indexOf(filter.operator) >= 0) {
                    var type = lodash.get(filter, 'type');
                    var isMultipleEnumType = $filter('isMultipleEnumType')(type);

                    var reduceFilterLabelArr = function (filterOptionsData) {
                        return function(accum, _value) {
                            var filteredOption = lodash.find(filterOptionsData, function(_filterOptionsData) {
                                var _filterOptionsDataValue = lodash.get(_filterOptionsData, 'value');
                                return _filterOptionsDataValue == _value;
                            });

                            var filteredOptionLabel = lodash.get(filteredOption, 'label');
                            if (filteredOptionLabel) {
                                accum.push(filteredOptionLabel);
                            }
                            
                            return accum;
                        }
                    }

                    if (isMultipleEnumType) {
                        var optionValueKeys = Object.keys(filter.option_value);
                        displayValue = optionValueKeys.reduce(function(result, optionValueKey) {
                            var _optionValue = lodash.get(filter.option_value, optionValueKey);
                            _optionValue = lodash.isArray(_optionValue) ? _optionValue : [_optionValue];
                            
                            var alternativeFilterOptionData = lodash.get(filter.options, ['data', optionValueKey].join('.'));
                            var filterOptionData = lodash.get(filter.options, [optionValueKey, 'data'].join('.'), alternativeFilterOptionData);
                            var singleFilterAccum = _optionValue.reduce(reduceFilterLabelArr(filterOptionData), []);
                            result = result.concat([singleFilterAccum.join(', ')]);

                            return result;
                        }, []);
                        displayValue = displayValue.join(' & ');
                    } else {
                        displayValue = filter.option_value.reduce(reduceFilterLabelArr(filter.options.data), []);
                        displayValue = displayValue.join(', ');
                    }

                }
                if ([ FILTER_OPERATOR_CONSTANT.IS].indexOf(filter.operator) >= 0) {
                    displayValue = filter.option_label;
                }
                if (filter.type === 'date') {
                    if ([FILTER_OPERATOR_CONSTANT.BETWEEN, FILTER_OPERATOR_CONSTANT.RANGE].indexOf(filter.operator) >= 0) {
                        displayValue = [
                            $filter('date')(displayValue.lower, lodash.get(filter, 'format', 'dd/MM/yyyy')),
                            'and',
                            $filter('date')(displayValue.upper, lodash.get(filter, 'format', 'dd/MM/yyyy')),
                        ].join(' ');
                    } else {
                        displayValue = $filter('date')(displayValue, lodash.get(filter, 'format', 'dd/MM/yyyy'));
                    }
                }
                if (filter.type === 'number') {
                    if ([FILTER_OPERATOR_CONSTANT.BETWEEN].indexOf(filter.operator) >= 0) {
                        displayValue = [
                            $filter('number')(displayValue.lower),
                            'to',
                            $filter('number')(displayValue.upper),
                        ].join(' ');
                    }
                    if ([FILTER_OPERATOR_CONSTANT.EXISTS, FILTER_OPERATOR_CONSTANT.NOT_EXISTS].indexOf(filter.operator) >= 0) {
                        displayValue = '';
                        $filter('number')(displayValue);
                    }
                }
            }
            return $filter('stringFormat')(filter.displayTemplate, [filter.label, filter.operator_label, displayValue]);

        };
    }
})();